import { render, staticRenderFns } from "./EspacoViverBemComponente.vue?vue&type=template&id=30660788&scoped=true"
import script from "./EspacoViverBemComponente.vue?vue&type=script&lang=js"
export * from "./EspacoViverBemComponente.vue?vue&type=script&lang=js"
import style0 from "./EspacoViverBemComponente.vue?vue&type=style&index=0&id=30660788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30660788",
  null
  
)

export default component.exports